
const ContactSection = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    // 폼 데이터를 URLSearchParams로 변환
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    fetch('https://readdy.ai/api/form/d5pbe34ue1sdfststj7g', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data
    })
    .then(response => {
      if (response.ok) {
        alert('문의가 성공적으로 전송되었습니다!');
        form.reset();
      } else {
        alert('전송 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('전송 중 오류가 발생했습니다. 다시 시도해주세요.');
    });
  };

  return (
    <section id="contact-section" className="py-32 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-7xl md:text-8xl font-extrabold text-[#1a1a1a] mb-6 leading-tight">
              Contact
            </h2>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Left: Contact Info */}
            <div className="space-y-12">
              <div>
                <h3 className="text-2xl font-semibold text-[#1a1a1a] mb-6">연락처</h3>
                <div className="space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-black text-white flex items-center justify-center">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm text-[#888888] mb-1">이메일</p>
                      <a 
                        href="mailto:hello@lilyxglobal.com"
                        className="text-lg text-[#1a1a1a] font-medium hover:text-[#555555] transition-colors"
                      >
                        hello@lilyxglobal.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-black text-white flex items-center justify-center">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm text-[#888888] mb-1">전화</p>
                      <a 
                        href="tel:070-8983-7994"
                        className="text-lg text-[#1a1a1a] font-medium hover:text-[#555555] transition-colors"
                      >
                        070-8983-7994
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Right: Contact Form */}
            <div>
              <form onSubmit={handleSubmit} data-readdy-form className="space-y-6">
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-[#555555] mb-2">
                    회사명 *
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="contact_name" className="block text-sm font-medium text-[#555555] mb-2">
                    담당자명 *
                  </label>
                  <input
                    type="text"
                    id="contact_name"
                    name="contact_name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-[#555555] mb-2">
                    이메일 *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-[#555555] mb-2">
                    연락처
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-[#555555] mb-2">
                    문의내용 *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    required
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm resize-none text-[#888888]"
                    placeholder="제휴 문의 내용을 입력해주세요 (최대 500자)"
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-black text-white py-4 hover:bg-gray-800 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer flex items-center justify-center group"
                >
                  제휴 문의하기
                  <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform duration-300"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
